import { render, staticRenderFns } from "./SwappTasksSupervisorIssueDialog.vue?vue&type=template&id=55e992ce&scoped=true"
import script from "./SwappTasksSupervisorIssueDialog.vue?vue&type=script&lang=js"
export * from "./SwappTasksSupervisorIssueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e992ce",
  null
  
)

export default component.exports